// ═══════════════════════════════════════════════════════════
// STAGES
// ═══════════════════════════════════════════════════════════
export const STAGES = [
  "New",
  "Qualified",
  "Proposal",
  "Negotiation",
  "Closed Won",
  "Closed Lost",
];

export const CLOSED_STAGES = ["Closed Won", "Closed Lost"];

export const STAGE_CFG = {
  "New":          { bg: "#E3F2FD", text: "#1565C0", accent: "#1565C0", dot: "#1565C0" },
  "Qualified":    { bg: "#F3E5F5", text: "#6A1B9A", accent: "#AB47BC", dot: "#AB47BC" },
  "Proposal":     { bg: "#FFF8E1", text: "#E65100", accent: "#FB8C00", dot: "#FB8C00" },
  "Negotiation":  { bg: "#FCE4EC", text: "#B71C1C", accent: "#E53935", dot: "#E53935" },
  "Closed Won":   { bg: "#E0F2F1", text: "#00695C", accent: "#00897B", dot: "#00897B" },
  "Closed Lost":  { bg: "#F5F5F5", text: "#616161", accent: "#9E9E9E", dot: "#9E9E9E" },
};

// ═══════════════════════════════════════════════════════════
// PRIORITY
// ═══════════════════════════════════════════════════════════
export const PRIORITY_LEVELS = ["Critical", "High", "Medium", "Low"];

export const PRIORITY_COLOR = {
  "Critical": "#E53935",
  "High":     "#FB8C00",
  "Medium":   "#1E88E5",
  "Low":      "#43A047",
};

// ═══════════════════════════════════════════════════════════
// PIPELINES
// ═══════════════════════════════════════════════════════════
export const PIPELINES = [
  "Management Consulting",
  "Financial Consulting",
  "Legal Consulting",
  "Other",
];

// ═══════════════════════════════════════════════════════════
// SOURCES
// ═══════════════════════════════════════════════════════════
export const SOURCES = [
  "Website",
  "Referral",
  "Social Media",
  "Email Campaign",
  "Cold Call",
  "Trade Show",
  "Partner",
  "Other",
];

// ═══════════════════════════════════════════════════════════
// CONTACT METHODS
// ═══════════════════════════════════════════════════════════
export const CONTACT_METHODS = [
  "Email",
  "Phone",
  "WhatsApp",
  "Social Media",
  "In Person",
  "Text Message",
];

// ═══════════════════════════════════════════════════════════
// TAGS
// ═══════════════════════════════════════════════════════════
export const ALL_TAGS = [
  { label: "Management Consulting", color: "#1976D2" },
  { label: "Financial Consulting",  color: "#2E7D32" },
  { label: "Legal Consulting",      color: "#6A1B9A" },
  { label: "Consulting",            color: "#0097A7" },
  { label: "Urgent",                color: "#E53935" },
  { label: "Premium Client",        color: "#F9A825" },
  { label: "Follow Up",             color: "#FB8C00" },
  { label: "Other",                 color: "#757575" },
];

// ═══════════════════════════════════════════════════════════
// TEAM
// ⚠️  Always empty here — real names come from Supabase
//     via useTeamMembers() → src/hooks/useTeamMembers.js
//     which reads from the team_members table (Staff Management)
// ═══════════════════════════════════════════════════════════
export const TEAM = [];

// ═══════════════════════════════════════════════════════════
// INDUSTRIES
// ═══════════════════════════════════════════════════════════
export const INDUSTRIES = [
  "Agriculture", "Apparel", "Banking", "Biotechnology", "Chemicals",
  "Communications", "Construction", "Consulting", "Education", "Electronics",
  "Energy", "Engineering", "Entertainment", "Environmental", "Finance",
  "Food & Beverage", "Government", "Healthcare", "Hospitality", "Insurance",
  "Machinery", "Manufacturing", "Media", "Not For Profit", "Other",
  "Recreation", "Retail", "Shipping", "Technology", "Telecommunications",
  "Transportation", "Utilities",
];

export const CONTACT_CATEGORIES = [
  "Customer", "Competitor", "Lead", "Partner", "Prospect",
];

export const TITLES = [
  "Mr.", "Mrs.", "Ms.", "Mx.", "Dr.", "Prof.",
];

// ═══════════════════════════════════════════════════════════
// SEED DATA — sample opportunities
// ═══════════════════════════════════════════════════════════
export const SEED_OPPS = [
  {
    id: 1,
    name: "Management Consulting — Org Restructuring",
    company: "Future Development Co.",
    contact: "CORE",
    phone: "+966 50 123 4567",
    email: "info@coreprofessional.sa",
    amount: 45000, probability: 70,
    stage: "Qualified",
    tags: [{ label: "Management Consulting", color: "#1976D2" }],
    assignee: null,
    startDate: "2026-02-25", endDate: "2026-04-30",
    activities: "Today's Activities",
    priority: "High", source: "Referral",
    contactMethod: "Email",
    pipeline: "Management Consulting",
    notes: "Client requires a full organizational restructuring.",
    archived: false, repeatCustomer: false, attachments: [],
  },
  {
    id: 2,
    name: "Financial Consulting — Asset Valuation",
    company: "Al-Noor Holding Group",
    contact: "Sara Al-Zahrani",
    phone: "+966 55 987 6543",
    email: "sara@alnoor.sa",
    amount: 80000, probability: 55,
    stage: "Proposal",
    tags: [{ label: "Financial Consulting", color: "#2E7D32" }],
    assignee: null,
    startDate: "2026-02-20", endDate: "2026-05-15",
    activities: null,
    priority: "Critical", source: "Website",
    contactMethod: "Phone",
    pipeline: "Financial Consulting",
    notes: "Full asset valuation ahead of merger.",
    archived: false, repeatCustomer: true, attachments: [],
  },
  {
    id: 3,
    name: "Legal Consulting — Partnership Contracts",
    company: "Al-Binaa Construction Co.",
    contact: "Khalid Al-Otaibi",
    phone: "+966 56 234 5678",
    email: "khalid@albinaa.sa",
    amount: 25000, probability: 80,
    stage: "Negotiation",
    tags: [{ label: "Legal Consulting", color: "#6A1B9A" }],
    assignee: null,
    startDate: "2026-01-15", endDate: "2026-03-30",
    activities: "Today's Activities",
    priority: "Medium", source: "Referral",
    contactMethod: "WhatsApp",
    pipeline: "Legal Consulting",
    notes: "Drafting and reviewing strategic partnership contracts.",
    archived: false, repeatCustomer: false, attachments: [],
  },
  {
    id: 4,
    name: "Management Consulting — Training Programs",
    company: "Advanced Technology Institute",
    contact: "Noura Al-Omari",
    phone: "+966 54 345 6789",
    email: "noura@atec.sa",
    amount: 35000, probability: 100,
    stage: "Closed Won",
    tags: [
      { label: "Management Consulting", color: "#1976D2" },
      { label: "Premium Client",        color: "#F9A825" },
    ],
    assignee: null,
    startDate: "2026-01-01", endDate: "2026-03-01",
    activities: null,
    priority: "High", source: "Partner",
    contactMethod: "Email",
    pipeline: "Management Consulting",
    notes: "Deal closed successfully. Implementation started.",
    archived: false, repeatCustomer: true, attachments: [],
  },
  {
    id: 5,
    name: "Financial Consulting — Debt Restructuring",
    company: "Al-Mustaqbal Investment Co.",
    contact: "Faisal Al-Harbi",
    phone: "+966 58 456 7890",
    email: "faisal@mustaqbal.sa",
    amount: 120000, probability: 20,
    stage: "Closed Lost",
    tags: [{ label: "Financial Consulting", color: "#2E7D32" }],
    assignee: null,
    startDate: "2025-12-01", endDate: "2026-02-01",
    activities: null,
    priority: "High", source: "Cold Call",
    contactMethod: "Phone",
    pipeline: "Financial Consulting",
    notes: "Client chose a competitor due to pricing.",
    archived: false, repeatCustomer: false, attachments: [],
  },
];

export const SEED_ACTIVITIES = [
  { id: 1, type: "note",  text: "Contacted the client — they expressed strong interest in the service.", date: "Feb 25, 2026", user: "" },
  { id: 2, type: "email", text: "Sent detailed proposal to client via email.",                           date: "Feb 24, 2026", user: "" },
  { id: 3, type: "call",  text: "Follow-up call — 20 min discussion on project timeline.",               date: "Feb 23, 2026", user: "" },
];

// ═══════════════════════════════════════════════════════════
// GLOBAL CSS
// ═══════════════════════════════════════════════════════════
export const GLOBAL_CSS = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300..1000;1,9..40,300..1000&display=swap');

/*
  ⚠️  SCOPED to .crm-root ONLY — do NOT use bare * or html,body selectors here.
  Those global selectors cause the sidebar to reflow/flicker when CRM mounts/unmounts
  because the <style> tag is injected into and removed from the DOM on navigation.
*/

/* Box model + resets — scoped to CRM container only */
.crm-root *,
.crm-root *::before,
.crm-root *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* Typography — scoped to CRM container only */
.crm-root {
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 14px;
  color: #1a1a2e;
}

/* Keyframes are global by nature but harmless — they don't affect layout */
@keyframes crm-slideInRight  { from{transform:translateX(100%);opacity:0} to{transform:translateX(0);opacity:1} }
@keyframes crm-slideInLeft   { from{transform:translateX(-100%);opacity:0} to{transform:translateX(0);opacity:1} }
@keyframes crm-fadeUp        { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:translateY(0)} }
@keyframes crm-fadeIn        { from{opacity:0} to{opacity:1} }
@keyframes pulse             { 0%,100%{opacity:1} 50%{opacity:.5} }

/* Scrollbar — scoped */
.crm-root ::-webkit-scrollbar        { width:4px; height:4px }
.crm-root ::-webkit-scrollbar-thumb  { background:#d4d4e8; border-radius:6px }

/* Form elements — scoped */
.crm-root input,
.crm-root select,
.crm-root textarea,
.crm-root button { font-family: inherit }
`;
